/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SyncTOTPRequest
 */
export interface SyncTOTPRequest {
    /**
     * 
     * @type {string}
     * @memberof SyncTOTPRequest
     */
    otp: string;
}

export function SyncTOTPRequestFromJSON(json: any): SyncTOTPRequest {
    return SyncTOTPRequestFromJSONTyped(json, false);
}

export function SyncTOTPRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncTOTPRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'otp': json['otp'],
    };
}

export function SyncTOTPRequestToJSON(value?: SyncTOTPRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'otp': value.otp,
    };
}


